import { createFileRoute } from "@tanstack/react-router";
import LinkRequestPage from "@/site/pages/link-request";

// One link request (PRD 16 §6.4 "The request"): what each side would share, Link or Not now.
// The link-request email lands here. Members only, full session (D4) — accepting shares the
// member's own birthday.
export const Route = createFileRoute("/linked/requests/$id")({
  component: LinkRequestPage,
});
